import React, { type MouseEventHandler } from 'react'
import { createPortal } from 'react-dom'
import './NotesSaveNoteModal.css'

type NotesUnsavedChangesModalProps = {
  show: boolean
  leaveMessage?: string
  onDismiss: () => void
  onDiscard: () => void
  onSave: () => void
}

const DEFAULT_LEAVE_MESSAGE = 'Please save your changes before leaving.'

const NotesUnsavedChangesModal: React.FC<NotesUnsavedChangesModalProps> = ({
  show,
  leaveMessage = DEFAULT_LEAVE_MESSAGE,
  onDismiss,
  onDiscard,
  onSave,
}) => {
  const handleDismissMouseDown: MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    event.preventDefault()
    event.stopPropagation()
    onDismiss()
  }

  const handleDiscardMouseDown: MouseEventHandler<HTMLButtonElement> = (
    event,
  ) => {
    event.preventDefault()
    event.stopPropagation()
    onDiscard()
  }

  const handleSaveMouseDown: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
    event.stopPropagation()
    onSave()
  }

  if (!show || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div className="notes-save-confirm" role="presentation">
      <div className="notes-save-confirm__scrim" aria-hidden="true" />
      <div
        className="notes-save-confirm__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="notes-unsaved-confirm-title"
      >
        <header className="notes-save-confirm__header">
          <h2
            id="notes-unsaved-confirm-title"
            className="notes-save-confirm__title"
          >
            Unsaved changes
          </h2>
          <button
            type="button"
            className="notes-save-confirm__close"
            aria-label="Close"
            onMouseDown={handleDismissMouseDown}
          >
            ×
          </button>
        </header>
        <div className="notes-save-confirm__body">
          <p className="notes-save-confirm__description">
            You have unsaved changes.
          </p>
          <p className="notes-save-confirm__description">{leaveMessage}</p>
        </div>
        <footer className="notes-save-confirm__footer">
          <div className="notes-save-confirm__actions">
            <button
              type="button"
              className="notes-save-confirm__btn notes-save-confirm__btn--secondary"
              onMouseDown={handleDiscardMouseDown}
            >
              Discard
            </button>
            <button
              type="button"
              className="notes-save-confirm__btn notes-save-confirm__btn--primary"
              onMouseDown={handleSaveMouseDown}
            >
              Save
            </button>
          </div>
        </footer>
      </div>
    </div>,
    document.body,
  )
}

export default NotesUnsavedChangesModal
